module.exports = __webpack_public_path__ + "static/media/KU.9e455134.png";